export enum UserRole {
  ADMIN = 'ROLE_ADMIN',
  CREATIVE = 'ROLE_CREATIVE',
  CLIENT = 'ROLE_CLIENT',
}
